<app-detail-form [fields]="fields()" [edit]="edit()" (fieldChange)="draft.change($event)" />
@if (edit()) {
  <app-form-actions class="block pt-4" [saveDisabled]="!isValid() || saving()" (cancelAction)="cancel()" (saveAction)="submit()" />
}
